import React, { useState } from 'react';
import { useAudio } from '../../contexts/AudioContext';

const DEFAULT_ART = 'https://images.pexels.com/photos/32589034/pexels-photo-32589034.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940';

export function AlbumArt({ size = 'large' }) {
  const { stationData, isPlaying, isLoading } = useAudio();
  const [imgError, setImgError] = useState(false);
  
  const artUrl = imgError ? DEFAULT_ART : (stationData?.now_playing?.song?.art || DEFAULT_ART);
  
  const sizeClasses = {
    small: 'w-16 h-16',
    medium: 'w-24 h-24 md:w-32 md:h-32',
    large: 'w-48 h-48 md:w-64 md:h-64 lg:w-72 lg:h-72'
  };

  return (
    <div 
      className={`relative ${sizeClasses[size]} group`}
      data-testid="album-art-container"
    >
      {/* Glow effect */}
      <div 
        className={`absolute inset-0 rounded-2xl blur-3xl transition-opacity duration-500 ${
          isPlaying ? 'opacity-40' : 'opacity-0'
        }`}
        style={{ 
          background: `linear-gradient(135deg, var(--primary) 0%, var(--secondary) 100%)` 
        }}
      />
      
      {/* Album art */}
      <div 
        className={`relative w-full h-full rounded-2xl overflow-hidden shadow-2xl transition-transform duration-500 ${
          isPlaying ? 'breathing' : ''
        }`}
      >
        {isLoading && (
          <div className="absolute inset-0 skeleton rounded-2xl" />
        )}
        <img
          src={artUrl}
          alt="Album Art"
          className={`w-full h-full object-cover transition-all duration-700 ${
            isLoading ? 'opacity-0' : 'opacity-100'
          }`}
          onError={() => setImgError(true)}
          data-testid="album-art-image"
        />
        
        {/* Overlay on hover */}
        <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
      </div>
    </div>
  );
}
